export default __webpack_public_path__ + "static/media/yen-listings.96f30ee0.png";